export default "__VITE_ASSET__DVpnSLMw__"